import { keys as headerKeys, values as headerValues } from '../../common/headers';
import { request } from '../../common/request';
import { skills as skillsUrl } from '../../common/urls';
import { log } from '../../common/log';
import { profile, updateProfile } from '../../common/profile';
import { PathLevel, PathRole, PathSolution, RecommendedID } from '../../common/keys';

function unsetLearningFilters(id = '') {
  sessionStorage.removeItem(PathSolution);
  localStorage.setItem(PathLevel, 'false');
  localStorage.setItem(PathRole, 'false');
  log(`Unset learning menu filters ${id}`);
}

export async function recommend(id = '', redirect = false, updateInterests = false, orchestrated = false) {
  try {
    const res = await request(`${skillsUrl}/${id}`, {
      headers: {
        [headerKeys.accept]: headerValues.json,
      },
    });

    if (res.ok) {
      const skill = await res.json();
      const ids = (skill.data.steps || []).reduce((a, v) => [...a, ...(v.Guide || []).map((g) => g.id)], []);

      if (ids.length > 0) {
        if (updateInterests) {
          const data = await profile();
          const interests = Array.from(new Set([...data.interests, ...skill.data.Solution]));

          await updateProfile('interests', interests, true);
          log(`Updated profile interests to ${id}`);
        }

        await updateProfile('recommended', ids, true);
        log(`Updated profile recommended content to ${id}`);

        if (redirect) {
          unsetLearningFilters(id);
          history.replaceState(null, '', `/home${location.search}`);

          if (location.hash.includes('dashboard') === false) {
            location.hash = 'dashboard/learning'; // driving UI back to dashboard after authentication
          }
        }
      }
    } else if (orchestrated) {
      sessionStorage.setItem(RecommendedID, id);
      log(`Failed to retrieve description of ${id}, tracking in sessionStorage as "${RecommendedID}"`);

      if (redirect) {
        unsetLearningFilters(id);

        if (location.hash.includes('dashboard') === false) {
          location.hash = 'dashboard/learning'; // driving UI back to dashboard after authentication
        }
      }
    }
  } catch (err) {
    log(`Failed to retrieve description of ${id}`);
  }
}
